import React, { useEffect, useMemo, useState } from 'react';
import CentralCalls from '../../../centralCalls';

function toOptionRow(row) {
	if (!row || typeof row !== 'object') {
		return null;
	}

	const label = typeof row.name === 'string' ? row.name.trim() : '';
	const value = row.name_id;
	if (!label || value === undefined || value === null) {
		return null;
	}

	return {
		label,
		value: String(value),
	};
}

function PhaseTypeFilterWidget({ value = '', onChange }) {
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const [loadError, setLoadError] = useState('');

	useEffect(() => {
		let active = true;

		const loadOptions = async () => {
			setLoading(true);
			setLoadError('');
			try {
				const rows = await CentralCalls.tableSelect('phase_type', {});
				if (!active) {
					return;
				}

				const normalized = (Array.isArray(rows) ? rows : [])
					.map(toOptionRow)
					.filter(Boolean)
					.sort((a, b) => a.label.localeCompare(b.label));

				setOptions(normalized);
			} catch (error) {
				if (!active) {
					return;
				}
				setOptions([]);
				setLoadError('Failed to load phase types.');
				console.error('Failed to load phase_type options', error);
			} finally {
				if (active) {
					setLoading(false);
				}
			}
		};

		void loadOptions();

		return () => {
			active = false;
		};
	}, []);

	const selectedValue = useMemo(() => {
		if (value === undefined || value === null) {
			return '';
		}
		return String(value);
	}, [value]);

	useEffect(() => {
		if (selectedValue || options.length === 0 || typeof onChange !== 'function') {
			return;
		}

		onChange(options[0].value);
	}, [selectedValue, options, onChange]);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-sm">
				<label className="mb-1 block text-[11px] font-medium uppercase tracking-wide text-slate-500">Phase Type</label>
				<select
					value={selectedValue}
					onChange={(event) => {
						if (typeof onChange === 'function') {
							onChange(event.target.value);
						}
					}}
					disabled={loading}
					className="h-9 w-full rounded-md border border-slate-300 bg-white px-3 text-xs text-slate-700 outline-none transition focus:border-slate-500 focus:ring-2 focus:ring-slate-200 disabled:cursor-not-allowed disabled:opacity-60"
				>
					{options.map((option) => (
						<option key={option.value} value={option.value}>
							{option.label}
						</option>
					))}
				</select>
				{loadError ? <div className="mt-1 text-[11px] text-red-700">{loadError}</div> : null}
			</div>
		</div>
	);
}

export default PhaseTypeFilterWidget;
